/**
 * Schreibt die Heizleistung in die Größen-Buttons des Variant-Pickers
 * und zeigt darunter eine Zusammenfassung zur gewählten Variante.
 *
 * Die Daten kommen aus einem JSON-Block, den blocks/varianten-leistung.liquid
 * rendert. Der Picker selbst bleibt unangetastet — fällt dieses Skript aus,
 * funktioniert die Seite unverändert weiter.
 */
(function () {
  'use strict';

  var nf = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });

  function konfiguration(wurzel) {
    var el = wurzel.querySelector('[data-varianten-leistung]');
    if (!el) return null;
    try {
      var d = JSON.parse(el.textContent);
      return d && d.werte && d.werte.length ? d : null;
    } catch (e) {
      return null;
    }
  }

  /** Buttons und Radios des Pickers einsammeln, unabhängig von der Darstellung */
  function auswahlElemente(wurzel) {
    return [].slice.call(
      wurzel.querySelectorAll(
        'label[data-option-value], .variant-option label, fieldset label, [data-option-value]'
      )
    );
  }

  /** Sichtbarer Text eines Auswahlelements, ohne bereits ergänzte Wattzeile */
  function beschriftung(el) {
    var klon = el.cloneNode(true);
    [].forEach.call(klon.querySelectorAll('.vl-watt'), function (x) { x.remove(); });
    return (klon.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function normal(s) {
    return String(s).toLowerCase().replace(/×/g, 'x').replace(/\s+/g, '');
  }

  /** In welcher Optionsposition steht die Größe? Nur die wird beschriftet. */
  function groessenPosition(werte) {
    var groesse = /^\d{2,3}x\d{2,3}$/;
    for (var pos = 1; pos <= 3; pos++) {
      var alle = true, wenigstensEiner = false;
      for (var i = 0; i < werte.length; i++) {
        var wert = werte[i]['o' + pos];
        if (!wert) { alle = false; break; }
        if (groesse.test(normal(wert))) wenigstensEiner = true;
        else { alle = false; break; }
      }
      if (alle && wenigstensEiner) return pos;
    }
    return 0;
  }

  /** Wattwert für eine Optionsbeschriftung finden — nur in der Größenspalte */
  function wattFuer(werte, text, pos) {
    if (!pos) return null;
    var norm = normal(text);
    for (var i = 0; i < werte.length; i++) {
      var wert = werte[i]['o' + pos];
      if (wert && normal(wert) === norm) return werte[i];
    }
    return null;
  }

  function schreibeButtons(wurzel, cfg) {
    var pos = groessenPosition(cfg.werte);
    if (!pos) return 0;

    var elemente = auswahlElemente(wurzel);
    var getroffen = 0;

    elemente.forEach(function (el) {
      if (el.querySelector('.vl-watt')) return;
      var text = beschriftung(el);
      if (!text) return;

      var treffer = wattFuer(cfg.werte, text, pos);
      if (!treffer) return;

      var span = document.createElement('span');
      span.className = 'vl-watt';
      span.textContent = nf.format(treffer.watt) + ' ' + (cfg.einheit || 'W');
      el.appendChild(span);
      getroffen++;
    });

    return getroffen;
  }

  function zusammenfassung(wurzel, cfg) {
    // Fix 05.10.2026: Die Box wird nur noch ersetzt, wenn sich ihr Inhalt ändert.
    // Vorher wurde sie bei jedem Durchlauf entfernt und neu eingefügt; das löste den
    // MutationObserver unten erneut aus → Endlosschleife (30 Neu-Einfügungen pro Sekunde).
    var vorhandene = wurzel.querySelector('[data-vl-info]');

    // Gewählte Variante: erst aus dem Formularfeld, dann aus der URL.
    // Horizon aktualisiert beides beim Umschalten.
    var id = null;
    var feld = wurzel.querySelector('input[name="id"], select[name="id"]');
    if (feld && feld.value) id = feld.value;
    if (!id) id = new URLSearchParams(window.location.search).get('variant');

    var v = null;
    if (id) {
      for (var i = 0; i < cfg.werte.length; i++) {
        if (String(cfg.werte[i].id) === String(id)) { v = cfg.werte[i]; break; }
      }
    }

    // Nicht jede Variante trägt eigene Wattwerte (z. B. "befüllt"-Varianten
    // beim Elektro-Modell). Dann zählt die gewählte Größe: gleiche Größe,
    // gleicher Heizstab — der Wert einer Schwester-Variante ist korrekt.
    if (!v) {
      var pos = groessenPosition(cfg.werte);
      if (pos) {
        var checked = wurzel.querySelectorAll('fieldset input:checked');
        for (var c = 0; c < checked.length && !v; c++) {
          var label = checked[c].closest('label');
          if (label) v = wattFuer(cfg.werte, beschriftung(label), pos);
        }
      }
    }
    // Ohne Treffer nichts anzeigen — falsche Werte wären schlimmer als keine
    if (!v) { if (vorhandene) vorhandene.remove(); return; }

    // Zellen (24.09.): links Heizleistung mit Raumgröße, rechts Wärmepumpe mit
    // eigener (kleinerer) Raumgröße. Ohne WP-Wert nur eine Zelle.
    var wattLabel = v.heizstab ? 'Heizstab-Leistung' : 'Heizleistung';
    function raumText(min, max, richtwert) {
      if (!max) return '';
      var r = min ? nf.format(min) + ' bis ' + nf.format(max) : 'bis ' + nf.format(max);
      return '<span class="vl-info__raum">' + (richtwert ? 'Richtwert ' : 'für ') + '<strong>' + r + ' m²</strong>' +
        (richtwert ? ' je nach Baujahr' : '') + '</span>';
    }
    // Standardbetrieb: gepflegte Raumwerte, sonst Richtwert nach derselben Formel
    // wie die Produktpflege (aufrunden: Watt/115 bis Watt/38)
    var raum1 = '';
    if (v.raumMax) raum1 = raumText(v.raumMin, v.raumMax, false);
    else if (v.watt) raum1 = raumText(Math.ceil(v.watt / 115), Math.ceil(v.watt / 38), true);
    var zellen = [];
    zellen.push('<div class="vl-info__zelle vl-info__zelle--klick" data-vl-rechner role="link" tabindex="0" aria-label="Zum Watt-Rechner"><span class="vl-info__label">' + wattLabel + '</span>' +
      '<span class="vl-info__wert">' + nf.format(v.watt) + ' W</span>' + raum1 +
      '<a class="vl-info__link" href="#heizlastrechner">Passt die Leistung zu Ihrem Raum? →</a></div>');
    if (v.wp) {
      var wpMax = v.wpRaumMax || Math.ceil(v.wp / 38);
      var wpMin = Math.ceil(v.wp / 115);
      zellen.push('<div class="vl-info__zelle"><span class="vl-info__label">Wärmepumpe</span>' +
        '<span class="vl-info__wert">' + nf.format(v.wp) + ' W</span>' + raumText(wpMin, wpMax, !v.wpRaumMax) + '</div>');
    }

    var klasse = 'vl-info vl-info--zellen' + (zellen.length === 1 ? ' vl-info--einzeln' : '');
    var html = zellen.join('');

    // Unverändert? Dann nichts anfassen — sonst meldet der Observer eine Änderung und wir drehen uns im Kreis.
    // Vergleich über einen Inhalts-Schlüssel statt innerHTML: der Browser serialisiert Attribute anders
    // als der Quelltext (z. B. data-vl-rechner → data-vl-rechner=""), innerHTML wäre nie gleich (09.10.).
    var schluessel = klasse + '|' + html;
    if (vorhandene && vorhandene.getAttribute('data-vl-key') === schluessel) return;

    var box = document.createElement('div');
    box.className = klasse;
    box.setAttribute('data-vl-info', '');
    box.setAttribute('data-vl-key', schluessel);
    box.innerHTML = html;

    if (vorhandene && vorhandene.parentNode) {
      vorhandene.parentNode.replaceChild(box, vorhandene);
      return;
    }
    var anker = wurzel.querySelector('variant-picker, .variant-picker, [data-variant-picker]');
    if (anker && anker.parentNode) {
      anker.parentNode.insertBefore(box, anker.nextSibling);
    }
  }

  function anwenden() {
    var wurzeln = document.querySelectorAll('[data-varianten-leistung]');
    [].forEach.call(wurzeln, function (json) {
      var wurzel = json.closest('.shopify-section, main, body') || document;
      var cfg = konfiguration(wurzel);
      if (!cfg) return;
      // Nur beschriften, wenn eine Optionsspalte durchgehend Größen enthält.
      // Sonst trägt allein die Zusammenfassung die Information.
      schreibeButtons(wurzel, cfg);
      zusammenfassung(wurzel, cfg);
    });
  }

  /* 09.10.2026: Link in der Heizleistungs-Zelle öffnet den Reiter „Watt-Rechner“ (Desktop Tab, mobil Accordion) */
  function zumRechner() {
    var kandidaten = [].filter.call(document.querySelectorAll('.ptabs__tab, .ptabs-acc'), function (el) {
      return /Watt-Rechner/i.test(el.textContent) && el.offsetParent !== null;
    });
    var ziel = kandidaten[0];
    if (ziel) {
      var panelId = (ziel.getAttribute('aria-controls') || '').split(' ')[0];
      var panel = panelId ? document.getElementById(panelId) : null;
      var offen = ziel.classList.contains('is-active') || (panel && panel.classList.contains('ptabs-acc-offen'));
      if (!offen) ziel.click();
    }
    // Immer zum Rechner selbst scrollen (nicht zum Reiter); kurz warten, bis der Reiter sichtbar ist
    setTimeout(function () {
      var hlr = document.getElementById('heizlastrechner') || document.querySelector('.hlr');
      var block = hlr && hlr.offsetParent !== null ? hlr : ziel;
      if (block) block.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 150);
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-vl-rechner]') : null;
    if (!a) return;
    e.preventDefault();
    zumRechner();
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.matches && e.target.matches('[data-vl-rechner]')) { e.preventDefault(); zumRechner(); }
  });

  function start() {
    anwenden();

    // Horizon tauscht Teile der Seite bei Variantenwechsel aus.
    // Nach jeder Änderung erneut anwenden, gedrosselt.
    var wartet = false;
    var beobachter = new MutationObserver(function () {
      if (wartet) return;
      wartet = true;
      window.requestAnimationFrame(function () {
        wartet = false;
        anwenden();
      });
    });
    beobachter.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
